<template>
  <div class="modal-default poa l0 t0 w100 h100 flex jcc aic zi1" v-if="value">
    <div class="modal-default-inner" @click.stop>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ModalDefault",
    props: {
      value: {
        type: Boolean | String,
        default: true,
      },
    },
    watch: {
      value(v) {
        this.$emit('input', v);
      },
      $route() {
        this.value = false;
      },
    },
    data() {
      return {};
    },
    mounted() {
      document.body.appendChild(this.$el);
    },
    methods: {}
  }
</script>

<style scoped lang="less">
  .modal-default {
    background-color: rgba(0, 15, 34, .4);
  }

</style>